<template>
    <div class="home data-panel-home">
        <Header title="历史账号迁移"></Header>
        <div class="accounts_container" v-if="status == 1">
            <div class="statusIcon">?</div>
            <p class="title1">还没有在公公众号绑定过账号</p>
            <p class="title2">请到账号绑定中完成账号绑定</p>
            <div class="button accountBtn">确 定</div>
        </div>
        <div class="accounts_container" v-else-if="status == 2">
            <div class="statusIcon">
                <img class="img1" src="../../assets/checksuccess.png" alt="">
            </div>
            <p class="title1">博纳云历史账号绑定成功</p>
            <p class="title2">在小程序中将同步博纳云历史账号信息</p>
        </div>
        <div class="accounts_container" v-else-if="status == 3">
            <div class="statusIcon">
                <img class="img2" src="../../assets/checkerror.png" alt="">
            </div>
            <p class="title1">绑定失败</p>
            <p class="title2">点击刷新重新绑定小程序账号</p>
            <div class="button accountBtn" @click="refreshUnify">刷 新</div>
        </div>
        <div class="accounts_container" v-else>
            <img class="loading" src="../../assets/loading.png" alt="">
            <p>加载中，请稍后</p>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from "vuex";
    import Header from "@/WechatComponents/Header.vue";
    const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
    import { getCookie } from "@/utils/utils";
    import { Message } from "element-ui";

    export default {
        name: "home",
        components: {
            Header
        },
        data() {
            return {
                status: 0,
                code: '',
            };
        },
        computed: mapState({
        }),
        created() {
            this.setUnifyAccount();
        },
        methods: {
            ...mapActions(["setWechatAccountUnify"]),
            async setUnifyAccount() {
                console.log(this.$route.query)
                this.code = this.$route.query.code;
                let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
                let redirect_url = this.$route.query.redirect_url || "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2faccountUnify";
                if (this.code) {
                    const res = await this.setWechatAccountUnify({ code: this.code });
                    console.log(res);
                    this.status = res.status;
                } else {
                    console.log(this.$route.query)
                    window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=987#wechat_redirect`;
                }
            },
            refreshUnify() {
                this.setUnifyAccount();
            }
        },
    };
</script>

<style lang="stylus">
    .data-panel-home.home {
        height: auto !important;

        .accounts_container {
            text-align: center;


            .statusIcon {
                width: 60px;
                height: 60px;
                background-color: #13B7BD;
                border-radius: 120px;
                text-align: center;
                line-height: 60px;
                color: white;
                font-size: 35px;
                margin: 0 auto;
                margin-top: 55px;
                margin-bottom: 17px;

                .img1 {
                    width: 31px;
                    height: 20px;
                }

                .img2 {
                    width: 24px;
                    height: 24px;
                }
            }

            .title1 {
                font-size: 16px;
                font-weight: 400;
                color: #27314A;
                line-height: 25px;
            }

            .title2 {
                font-size: 14px;
                font-weight: 400;
                color: #8F94A7;
                line-height: 30px;
            }

            .accountBtn {
                width: 163px;
                height: 39px;
                background: #13B7BD;
                border-radius: 6px;
                font-size: 17px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 39px;
                margin-top: 27px;
            }

            .loading {
                width: 60px;
                height: 60px;
                margin-top: 55px;
                margin-bottom: 30px;
            }
        }
    }

    .wechat-home {
        background: #fff;
        text-align: center;
        padding: 20px;
    }
</style>